var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8047 8.96875L10.9297 15.8438C10.6953 16.0781 10.2656 16.0781 10.0312 15.8438C9.79688 15.6094 9.79688 15.1797 10.0312 14.9453L15.8516 9.125H1.125C0.773438 9.125 0.5 8.85156 0.5 8.5C0.5 8.1875 0.773438 7.875 1.125 7.875H15.8516L10.0312 2.09375C9.79688 1.85938 9.79688 1.42969 10.0312 1.19531C10.2656 0.960938 10.6953 0.960938 10.9297 1.19531L17.8047 8.07031C18.0391 8.30469 18.0391 8.73438 17.8047 8.96875Z",
    fill: "#F79831"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.3d02036b44e1f61e7d0b4f082938b96f.svg";
export { ForwardRef as ReactComponent };